module.exports = __webpack_public_path__ + "img/request-document_active.99992e29.svg";